import { selectBestOffers } from './offerSelection.js';
/**
 * Utility class that represents (and eases) the state management around selecting offers from a set
 *
 * Supply it with offers and merchant/affiliate preferences, and how many offers are desired, then
 * ask it for the primary (first) offer, or a full offer set depending on need.
 */
export class OfferSelectionContainer {
    set desiredOfferCount(desired) {
        this.needsReselect = desired !== this._desiredOfferCount;
        this._desiredOfferCount = desired;
    }
    get selectedOffers() {
        if (this.needsReselect) {
            this.select();
        }
        return this._selectedOffers;
    }
    get primaryOffer() {
        if (this.needsReselect) {
            this.select();
        }
        return this._selectedOffers === undefined ? undefined : this._selectedOffers[0];
    }
    constructor(offers, preferredMerchantIds, preferredAffiliateIds, desiredOfferCount = 3) {
        this.offers = offers;
        this.preferredMerchantIds = preferredMerchantIds;
        this.preferredAffiliateIds = preferredAffiliateIds;
        this.needsReselect = true;
        this._desiredOfferCount = 0;
        this.desiredOfferCount = desiredOfferCount;
        this.needsReselect = true;
    }
    select() {
        this._selectedOffers = selectBestOffers(this.offers, this._desiredOfferCount, this.preferredMerchantIds, this.preferredAffiliateIds);
        this.needsReselect = false;
    }
}
//# sourceMappingURL=offerSelectionContainer.js.map